export const RESTAURANT = 0;
export const CAFE = 1;
export const BAR = 2;
export const ROOM_SERVICE = 3;
export const ACCEPT_ORDERS_WITHOUT_TAB=true